import { debounce } from "lodash";
import { useCallback, useEffect, useRef } from "react";

export function useKeyboardShortcut(shortcutSequence, callback, delay = 500, enabled = false) {
  const callbackRef = useRef(callback);
  const comboKeys = useRef([]);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const isInputFocused = () => {
    const activeElement = document.activeElement;
    return (
      activeElement.tagName === "INPUT" ||
      activeElement.tagName === "TEXTAREA" ||
      activeElement.tagName === "SELECT" ||
      activeElement.isContentEditable
    );
  };

  const executeCombo = useCallback(
    debounce(() => {
      if (!enabled) return;
      if (isInputFocused()) {
        comboKeys.current = [];
        return;
      }

      const sequence = comboKeys.current.join("+");
      if (sequence === shortcutSequence) {
        callbackRef.current();
      }
      comboKeys.current = [];
    }, delay),
    [shortcutSequence, delay, enabled]
  );

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      if (isInputFocused()) return;
      comboKeys.current.push(event.key.toLowerCase());
      executeCombo();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      executeCombo.cancel();
    };
  }, [executeCombo, enabled]);
}
